export const firebaseConfig = {
    apiKey: "AIzaSyDZWatyzTzTfesFZrr-Lg9czitKgBJasxE",
  
    authDomain: "qid-dev.firebaseapp.com",
  
    projectId: "qid-dev",
  
    storageBucket: "qid-dev.firebasestorage.app",
  
    messagingSenderId: "823101334957",
  
    appId: "1:823101334957:web:d30a5d5c1e9fa99947ad24",
  
    measurementId: "G-4WDTFDNTTX"
  
    };